export default __webpack_public_path__ + "static/media/banks.7e9291ad.svg";